import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import '../../../style/ReactMediaPlayer.css';
import { Media, controls } from 'components/ReactMediaPlayerSrc';
import PlayPause from './PlayPause';

const { SeekBar } = controls;

class CustomSeekBar extends Component {
  static contextTypes = {
    isPlaying: PropTypes.bool
  };

  render() {
    return (
      <div style={{ minHeight: '10px' }}>
        {this.context.isPlaying ? <SeekBar className={this.props.className} /> : null}
      </div>
    );
  }
}

export default class AudioPlayer extends Component {
  render() {
    if (!this.props.src) return null;
    const seekBarClass = classNames('media-control', { 'mini-seek-bar': this.props.onlySeekbar });
    const mediaControlsClass = classNames('media-controls', {
      'mini-mode': this.props.onlySeekbar
    });
    console.log('this.props.autoPlay::', this.props.autoPlay);
    const autoPlay = 'autoPlay' in this.props ? this.props.autoPlay : false;
    return (
      <div className="react-media-player">
        <Media src={this.props.src} autoPlay={autoPlay} vendor="audio">
          {Player => (
            <div>
              {Player}
              <nav className={mediaControlsClass} style={this.props.controlsWrapperStyle || null}>
                <CustomSeekBar className={seekBarClass} />
                <PlayPause
                  className="media-control media-control--play-pause"
                  cancelRecorded={this.props.cancelRecorded}
                />
              </nav>
            </div>
          )}
        </Media>
      </div>
    );
  }
}
